import { SUB_BUTTON_ACTIONS } from "./../../../constants";
import endCall from "./../../../assets/end-call.svg";
import startCall from "./../../../assets/start-call.svg";
import enabledMic from "./../../../assets/mic/enabled-mic.svg";
import disabledMic from "./../../../assets/mic/disabled-mic.svg";

export const CALL_ACTIONS = {
  MUTE: 'mute',
  UNMUTE: 'unmute',
  HOLD: 'hold',
  RESUME: 'resume',
  TRANSFER: 'transfer',
  END_CALL: 'endCall',
  START_CALL : 'startCall'
};

const BASIC_CALL_ACTIONS = {
  [SUB_BUTTON_ACTIONS.HOLD]:{
    'false':{
      label: 'Resume',
      actions: {
        'onClick' : 'hold'
      },
      icon: startCall,

    },
    'true':{
      label: 'Hold',
      actions: {
        'onClick' : 'hold'
      },
      icon: startCall,
    }
  },
  [SUB_BUTTON_ACTIONS.MUTE] : {
    'false':{
      label: 'Unmute',
      actions: {
        'onClick' : 'mute'
      },
      icon: disabledMic,
    },
    'true':{
      label: 'Mute',
      actions: {
        'onClick' : 'mute'
      },
      icon: enabledMic,
    }
  },
  [SUB_BUTTON_ACTIONS.END] : {
    'false':{
      label : "Start call",
      actions: {
        'onClick' : 'end'
      },
      icon: endCall,
    },
    'true':{
      label : "End call",
      actions: {
        'onClick' : 'end'
      },
      icon: endCall,
    }
  }
};

export {
    BASIC_CALL_ACTIONS
}